<template>
  <div class="tab-component">
    <div class="tab-component-inner">
      <div
        :class="{'tab-item': true, 'tab-active': index === tabValue}"
        v-for="(item, index) in titleList"
        :key="item + index"
        @click="change(index)"
      >
        {{item}}
        <div :class="{'tab-item-fff': true, 'tab-item-blue': index === tabValue}"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent, watchEffect } from 'vue';

export default defineComponent({
  props: {
    titleList: {
      type: Array,
      default: () => [],
    },
    tabValue: {
      type: Number,
      default: 0,
    }
  },
  setup(props, context) {
    watchEffect(() => {
      const dom = document.querySelector('.tab-component .tab-component-inner');
      if (props.tabValue < 3) {
        dom && dom.scrollTo(0, 0);
      } else {
        dom && dom.scrollTo(120 * (props.tabValue - 2), 0);
      }
    });
    const change = (value) => {
      context.emit('change', value)
    };
    return {
      change,
    }
  },
})
</script>
<style lang="scss" scoped>
.tab-component {
  width: 100%;
  .tab-component-inner {
    white-space: nowrap;
    overflow-x: scroll;
    font-size: 14px;
    color: #000;
    .tab-item {
      display: inline-block;
      padding: 12px 10px;
      opacity: .8;
      position: relative;
      .tab-item-fff {
        position: absolute;
        width: 0px;
        height: 3px;
        background-color: #0087FF;
        border-radius: 1.5px;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        transition: width .3s ease;
      }
      .tab-item-blue {
        width: 30px;
        transition: width .3s ease;
      }
    }
    .tab-active {
      font-weight: bold;
      opacity: 1;
    }
  }
  .tab-component-inner::-webkit-scrollbar {
  display: none;
}
}
</style>